import { combineEpics } from "redux-observable";
import { epicLandingPageLogin } from "./epicLandingPageLogin";
import { epicLandingPageLogout } from "./epicLandingPageLogout";
export var epicLandingPage = combineEpics(epicLandingPageLogin, epicLandingPageLogout);



//////////////////
// WEBPACK FOOTER
// ./src/features/landing-page/epicLandingPage.ts
// module id = 1979
// module chunks = 3